import React from 'react';
import { BentoGrid } from './BentoGrid';
import { CtaBand } from './CtaBand';
import { FaqAccordion } from './FaqAccordion';
import { IntegrationStrip } from './IntegrationStrip';
import { LandingFooter } from './LandingFooter';
import { LandingHero } from './LandingHero';
import { LandingNav } from './LandingNav';
import { OutcomeRow } from './OutcomeRow';
import { PlanTeaser } from './PlanTeaser';
import { ProofSection } from './ProofSection';
import { StepList } from './StepList';

/**
 * `/v2` — the marketing surface (DESIGN_PLAN §1).
 *
 * What makes this safe to add: no API calls, no auth reads, no user data, no
 * forms. Signup already lives at `/login`, so there is nothing to collect here,
 * and every primary CTA on the page carries the same label and the same
 * destination — one objective, one funnel.
 *
 * Section order matches §1.1. `ProofSection` is section 6 and currently renders
 * nothing (see its file), so 5 flows into 7 with no visible gap.
 */
export const LandingPage: React.FC = () => (
  <div data-v2-root="landing" className="min-h-screen bg-[#0a0a0a] font-sans text-white">
    <LandingNav />
    <main>
      <LandingHero />
      <IntegrationStrip />
      <OutcomeRow />
      <BentoGrid />
      <ProofSection />
      <StepList />
      <PlanTeaser />
      <FaqAccordion />
      <CtaBand />
    </main>
    <LandingFooter />
  </div>
);

export default LandingPage;
